import React, { useEffect, useState } from 'react'
import { Box, Grid, } from "@mui/material";
import TextLabel from '../Common/Fields/TextLabel';
import CommonTextField from '../Common/Fields/TextField';
import CommonButton from '../Common/Button/CommonButton';

const AddSiteType = ({ data, error, handleChange, isEdit, onSubmit, setSelectedCountry }) => {

    return (
        <Box>
            <Grid container spacing={1} xs={12} md={12} lg={12} sm={12} p={2}>

                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <CommonTextField
                        fontWeight={400}
                        text={'SiteType'}
                        placeholder={"Enter SiteType"}
                        type='text'
                        name='siteType'
                        value={data?.siteType}
                        onChange={(e) => handleChange(e, false)}
                    />
                    <TextLabel fontSize={"12px"} color={"red"} fontWeight={"400"} title={!data?.siteType ? error?.siteType : ""} />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <CommonTextField
                        fontWeight={400}
                        text={'SiteType description'}
                        placeholder={"Enter SiteType Description"}
                        type='text'
                        name='description'
                        value={data?.description}
                        onChange={(e) => handleChange(e, false)}
                        multiline={true}
                    />
                    <TextLabel fontSize={"12px"} color={"red"} fontWeight={"400"} title={!data?.description ? error?.description : ""} />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Box style={{ display: 'flex', justifyContent: 'center', marginTop: '35px' }}>
                        <CommonButton
                            width={'280px'}
                            text={`${isEdit ? "Update" : "Create"} siteType`}
                            type="submit"
                            onClick={onSubmit}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}

export default AddSiteType